import { ReactNode, useMemo, useState } from "react";
import { Swarm } from "@lbs/swarm-client";

import Select from "src/common/components/select";
import { getGameAllMarketsSwarmQuery } from "src/common/swarm/queries/events";
import { ISelection } from "src/constants/interfaces/bet";
import MarketBase from "../../../../common/components/marketBase";
import { getEventsFromMarket, SwarmMarketEvent } from "src/common/swarm/destructure";
import { IDropdownOption } from "src/constants/interfaces";
import MarketSelectItem from "../marketSelectItem";

import "./style.scss";

interface IProps {
	selection: ISelection;
	onChange(data: SwarmMarketEvent): void;
}

const MarketChangeDropdown = ({ selection, onChange }: IProps) => {
	const [events, setEvents] = useState<SwarmMarketEvent[]>([]);

	const [selectOptions, selected] = useMemo(() => {
		const options = events.map(({ event, market }) => ({
			name: (
				<MarketSelectItem
					eventName={selection.event.name}
					eventPrice={event.price}
					marketBase={event.base}
				/>
			),
			value: event.id,
		}));

		return [options, options.find(item => item.value === selection.event.id)];
	}, [events, selection]);

	const onToggleOpen = async (open: boolean) => {
		if (open) {
			const { event, game, market } = selection;
			const { data: { data: response = {} } = {} } = await Swarm.getInstance().getData(
				getGameAllMarketsSwarmQuery(game.id, market.market_type, event.type)
			);

			setEvents(getEventsFromMarket(response.data.market));
		}
	};

	const changeMarket = ({ value }: IDropdownOption<ReactNode, number>) => {
		const newEvent = events.find(item => item.event.id === value);
		newEvent && onChange(newEvent);
	};

	return (
		<Select
			value={selected?.value}
			placeholder={
				<>
					<span className="B-market-name">{selection.event.name}</span>{" "}
					<MarketBase base={selection.event.base} />
				</>
			}
			options={selectOptions}
			onToggleOpen={onToggleOpen}
			onChange={changeMarket}
			showSelected={false}
			className="B-market-change-dropdown"
		/>
	);
};

export default MarketChangeDropdown;
